<template>
  <div>
    <b-card class="pa-0 mb-3">
      <b-row>
        <b-col cols="12" md="6">
          <label class="font-weight-bold mb-2">Organ Type</label>
          <b-form-radio-group
            v-model="organType"
            :options="organTypes"
            buttons
            button-variant="outline-primary"
          ></b-form-radio-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="pa-0 tabs">
      <Tabs :theme="theme" v-model="tab">
        <TabItem v-for="(item, i) in tabs" :key="i" :name="item">
          <template #name>
            {{ item }}
          </template>
        </TabItem>
      </Tabs>
    </b-card>
    <hospital-rota-order
      v-show="tab == 'Zone Rota'"
      :organType="organType"
    ></hospital-rota-order>
    <government-rota-order
      v-show="tab == 'Government Rota'"
      :organType="organType"
    ></government-rota-order>
  </div>
</template>

<script>
import GovernmentRotaOrder from "../../components/hospitals/hospitalRotaOrder/GovernmentRotaOrder.vue";
import HospitalRotaOrder from "../../components/hospitals/hospitalRotaOrder/HospitalRotaOrder.vue";
export default {
  components: { HospitalRotaOrder, GovernmentRotaOrder },
  data() {
    return {
      theme: {
        nav: "white",
        navItem: "#BDBDBD",
        navActiveItem: "#556ee6",
        slider: "#556ee6",
        arrow: "#556ee6",
      },
      tabs: ["Zone Rota", "Government Rota"],
      tab: "Zone Rota",
      organType: 103,
      organTypes: [
        { text: "Liver", value: 103 },
        { text: "Heart", value: 106 },
        { text: "Lung", value: 107 },
      ],
    };
  },
};
</script>

<style>
</style>
